<canvas #riveCanvas width="1024" height="1024"> </canvas>
